<template>
  <div class="cesta__fila">
    <div class="cesta__imagen">
      <a :href="producto.enlace">
        <img :src="'/min'+producto.imagen" class="img-responsive" width="307" height="409" :alt="producto.nombre">
      </a>
    </div>
    <div class="titulo-cesta">
      <a :href="producto.enlace">{{ producto.nombre }}</a>
    </div>
    <div class="cesta__cantidad cantidad">
      <div class="ctr-button ctr-cesta-cantidad">
        <button type="button" class="cesta-entero-desc entero-desc" @click="cambiarCantidad(-1)">
          <i class="fa fa-minus" aria-hidden="true"></i>
        </button>
        <input class="form-control" ref="cantidad" :name="clave+'[cantidad]'" :value="cantidad" type="text" @change="cambiarCantidadAValorEntrado">
        <button type="button" class="cesta-entero-asc entero-asc" @click="cambiarCantidad(1)">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="cesta__precio">{{ precio }}</div>
    <div class="cesta__accion">
      <div class="cesta-item-borrar" @click="eliminaItem">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ItemCarrito",
  props: ['clave', 'cantidad', 'precio', 'producto'],
  emits: ["eliminado", "modificado"],
  mounted() {
    let vm = this;
  },
  methods: {
    cambiarCantidad: function (delta) {
      let dato = {
        clave: this.clave,
        cantidad: this.cantidad + delta,
      };

      this.$emit('modificado', dato)
    },
    cambiarCantidadAValorEntrado() {
      let cantidad = parseInt(this.$refs.cantidad.value);
      if (isNaN(cantidad)) {
        cantidad = 1;
      }
      if (cantidad < 1) {
        cantidad = 1;
      }
      let dato = {
        clave: this.clave,
        cantidad: cantidad,
      };

      this.$emit('modificado', dato)
    },
    eliminaItem: function () {
      this.$emit('eliminado', this.clave)
    },
  }
}
</script>